import React, { useState, useEffect } from 'react';
import JobText from './JobText';
import LaravelApi from '../../components/laravelApi/LaravelApi';
import work from '../../../assets/images/aboutMe/work.png';
import DateTimeTools from '../../tools/DateTimeTools';
import Spinner from '../../components/spinner/Spinner';
import { jobList } from '../../../fakeDatabase';
const JobList = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    //const response = await LaravelApi.get('/jobs', {});
    setData(jobList);
  }

  if (data != null) {
    const jobList = data.map(data => {
      var from = DateTimeTools.getFormatedTimeFromString(data.from);
      var to = DateTimeTools.getFormatedTimeFromString(data.to);

      return <JobText 
        key={data.company}
        company={data.company}  
        rol={data.rol}
        from={from}
        to={to}
        key={data.company}
      />
    });

    return (
      <div>
        <img className="ui small centered image" src={work} /> 
        <br></br>
        {jobList}
      </div>
    )
  }
  
  return (
    <Spinner />
  )
}

export default JobList;